<template>
  <div class="bbe-toolbar-template">
    <div class="bbe-toolbar-template-item"
         v-if="icon.visibility"
         v-for="icon in sortedIcons"
         :key="icon.id"
         @mouseenter="setEnter($event, icon)">
      <img class="bbe-toolbar-template-item__icon" :src="icon.src" @click.stop="setAction(icon)"/>
    </div>
  </div>
</template>

<script>
import icons from '@/constants/images'

export default {
  name: 'ToolbarTemplate',
  props: ['access', 'edit', 'delete', 'view', 'template'],
  data () {
    return {
      icons: [
        {
          id: 'access',
          src: icons.access,
          position: this.access.position,
          visibility: this.access.visibility,
          action: this.access.action
        },
        {
          id: 'edit',
          src: icons.edit,
          position: this.edit.position,
          visibility: this.edit.visibility,
          action: this.edit.action
        },
        {
          id: 'delete',
          src: icons.delete,
          position: this.delete.position,
          visibility: this.delete.visibility,
          action: this.delete.action
        },
        {
          id: 'view',
          src: icons.view,
          position: this.view.position,
          visibility: this.view.visibility,
          mouseenter: this.view.mouseenter
        }
      ],
      typesIcons: ['access', 'edit', 'delete', 'view']
    }
  },
  computed: {
    sortedIcons () {
      const sorted = [...this.icons].sort((a, b) => a.position - b.position)
      return sorted
    }
  },
  methods: {
    setAction (icon) {
      if (!icon.action) return
      icon.action(this.template)
    },
    setEnter (e, icon) {
      if (!icon.mouseenter) return
      icon.mouseenter(e)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../sass/variables";
  @import "../../../sass/mixins";

  .bbe-toolbar-template {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(21px, 1fr));
    grid-column-gap: 10px;
    align-items: center;
    max-width: 83px;
    user-select: none;

    &-item {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;

      &__icon {
        position: relative;
        width: 21px;
        height: 21px;
        border-radius: 50%;
        cursor: pointer;
        z-index: 1;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Templates/TemplatesSidebar/ToolbarTemplate.vue